import React, { useState } from "react";

import {
  BarsMiniIcon,
  ClockIcon,
  EyeIcon,
  EyeSlashIcon,
  UserGroupIcon,
} from "../../lib/icons";
import { IndofastLogo } from "../layout/IndofastLogo";

function LoginPage({
  error,
  loggingIn,
  loginForm,
  onChange,
  onSubmit,
}) {
  const [showPassword, setShowPassword] = useState(false);
  return (
    <div className="login-page">
      <div className="login-layout">
        <section className="login-hero">
          <div className="login-brand">
            <IndofastLogo height={40} variant="light" />
          </div>

          <div className="hero-copy">
            <p className="login-kicker">Sales CRM</p>
            <h1>Control your lead pipeline from one focused workspace.</h1>
            <p>Track queues, follow-ups, and conversions without switching between tools.</p>
          </div>

          <div className="login-feature-grid">
            <article className="login-feature-card">
              <span className="login-feature-icon">
                <UserGroupIcon />
              </span>
              <div>
                <strong>Assigned Lead Queues</strong>
                <p>Keep ownership clean for agents and managers.</p>
              </div>
            </article>

            <article className="login-feature-card">
              <span className="login-feature-icon">
                <ClockIcon />
              </span>
              <div>
                <strong>Follow-up Board</strong>
                <p>Work overdue, today, and upcoming callbacks in order.</p>
              </div>
            </article>

            <article className="login-feature-card">
              <span className="login-feature-icon">
                <BarsMiniIcon />
              </span>
              <div>
                <strong>Live Funnel Reports</strong>
                <p>Review source, city, region, and conversion performance.</p>
              </div>
            </article>
          </div>
        </section>

        <section className="login-panel">
          <p className="login-kicker">Sign In</p>
          <h2>Access your CRM workspace</h2>
          <p className="login-copy">
            Use your backend account credentials to start the session.
          </p>

          <form className="login-form" onSubmit={onSubmit}>
            <label className="field-stack">
              <span>Username</span>
              <input
                value={loginForm.username}
                onChange={(event) => onChange("username", event.target.value)}
                placeholder="Enter username"
                required
              />
            </label>

            <label className="field-stack">
              <span>Password</span>
              <div className="password-input-wrapper">
                <input
                  type={showPassword ? "text" : "password"}
                  value={loginForm.password}
                  onChange={(event) => onChange("password", event.target.value)}
                  placeholder="Enter password"
                  required
                />
                <button
                  type="button"
                  className="password-toggle"
                  onClick={() => setShowPassword((v) => !v)}
                  tabIndex={-1}
                  aria-label={showPassword ? "Hide password" : "Show password"}
                >
                  {showPassword ? <EyeSlashIcon /> : <EyeIcon />}
                </button>
              </div>
            </label>

            {error ? <p className="message-banner error">{error}</p> : null}

            <button className="primary-login-button" disabled={loggingIn} type="submit">
              {loggingIn ? "Signing in..." : "Login to Indofast"}
            </button>
          </form>
        </section>
      </div>
    </div>
  );
}

export default LoginPage;
